
import React from 'react';

import IOption from '../../interfaces/IOption';

import styles from './styles.module.scss'

interface IColorsGrid {
  colors: IOption[]
}

export default function ColorsGrid({ colors }: IColorsGrid)  {
  const renderColors = () => {
    return colors.map((color) => {
      const colorTitle = color.value.toString().split("&")[1]
      return (
        <div key={color.value} className={styles.color} style={{ backgroundColor: color.label }} title={colorTitle}>
          &nbsp;
        </div>
      )
    })
  }
  
  return (
    <div className={styles.colorsGrid}>
      { renderColors() }
    </div>
  )
};
